"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../cjs/components/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var BitbucketBuildsIcon = function BitbucketBuildsIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\"><path d=\"M10 5a1 1 0 0 0 .997 1h3.006a1 1 0 0 0 0-2h-3.006C10.45 4 10 4.45 10 5zM8 5c0-1.657 1.347-3 2.997-3h3.006a3 3 0 0 1 0 6h-3.006A3 3 0 0 1 8 5zm2 7a1 1 0 0 0 .997 1h3.006a1 1 0 0 0 0-2h-3.006c-.547 0-.997.45-.997 1zm-2 0c0-1.657 1.347-3 2.997-3h3.006a3 3 0 0 1 0 6h-3.006A3 3 0 0 1 8 12zm2 7a1 1 0 0 0 .997 1h3.006a1 1 0 0 0 0-2h-3.006c-.547 0-.997.45-.997 1zm-2 0c0-1.657 1.347-3 2.997-3h3.006a3 3 0 0 1 0 6h-3.006A3 3 0 0 1 8 19z\"/><path d=\"M16.062 6h2.415c.812 0 1.472.66 1.472 1.47v1.954c0 .815-.654 1.47-1.475 1.47H16v2h2.474a3.466 3.466 0 0 0 3.475-3.47V7.47A3.472 3.472 0 0 0 18.477 4h-2.415v2zm-7.175 5H6.472A3.472 3.472 0 0 0 3 14.47v1.954c0 1.92 1.55 3.47 3.474 3.47H8.95v-2H6.474c-.82 0-1.474-.655-1.474-1.47V14.47c0-.81.66-1.47 1.472-1.47h2.415v-2z\"/></g></svg>"
  }, props));
};

BitbucketBuildsIcon.displayName = 'BitbucketBuildsIcon';
var _default = BitbucketBuildsIcon;
exports.default = _default;